import script from "./MobilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MobilePage.vue?vue&type=script&setup=true&lang=js"

import "./MobilePage.vue?vue&type=style&index=0&id=e86b5908&lang=scss"

const __exports__ = script;

export default __exports__